import React, { useState } from "react";
import { Lock, Eye, EyeOff, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import { recordLoginHistory } from "../../utils/loginHistory";
import { useAuth } from "../../context/AuthContext";
import { memoryStorage } from "../../utils/memoryStorage";

const PasswordLogin = ({ email, onBack, onSuccess }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [buttonState, setButtonState] = useState("default");
  const [remember, setRemember] = useState(false);

  const navigate = useNavigate();
  const { setUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password) {
      setError("Please enter your password");
      setButtonState("error");
      return;
    }

    try {
      setButtonState("loading");

      const res = await API.post(
        "/auth/login",
        { email, password },
        { withCredentials: true }
      );

      setUser(res.data.user);
      memoryStorage.setItem("user", JSON.stringify(res.data.user));
      recordLoginHistory(res.data.user);

      const role = (res.data.user?.role || "").toUpperCase();

      setButtonState("success");

      setTimeout(() => {
        if (role === "SUPER_ADMIN") {
          navigate("/components/Admins/AdminLayout/dashboard");
        } else if (role === "HR_ADMIN") {
          navigate("/HRadmin/HRAdminLayout");
        } else if (role === "CONTENT_MANAGER") {
          navigate("/ContentManager/ContentManagerLayout/dashboard");
        } else {
          navigate("/candidate/candidatecareer");
        }

        if (onSuccess) onSuccess();
      }, 300);
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
      setButtonState("error");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <button type="button" onClick={onBack}>
        <ArrowLeft size={16} /> Change email
      </button>

      <div>Signing in as {email}</div>

      <div>
        <Lock size={20} />
        <input
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="button" onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>

      {error && <p>{error}</p>}

      <button type="submit">
        {buttonState === "loading" ? "Signing in..." : "Login"}
      </button>

      <label>
        <input
          type="checkbox"
          checked={remember}
          onChange={(e) => setRemember(e.target.checked)}
        />
        Remember me
      </label>
    </form>
  );
};

export default PasswordLogin;
 